<div class="document-buttons" [ngClass]="{ 'document-buttons-chico': document_buttons_chico }">
  <div>
    <div id="btn-general" class="document-button" [ngClass]="activeForm == 'general' ? 'selected' : ''"
      (click)="emitchangeForm('general')" >
      <button type="submit" class="btn-documents">
        <i class="icon-clipboard-empty"></i>
        {{ "forms.buttons.general" | translate }}
        <span *ngIf="updatesTabs.includes('general')" class="violet-dot"></span>
      </button>
    </div>
    <div id="btn-vehicle" class="document-button" [ngClass]="activeForm == 'vehicle' ? 'selected' : ''"
      (click)="emitchangeForm('vehicle')" >
      <button type="submit" class="btn-documents">
        <i class="icon-car"></i>
        {{ "forms.buttons.vehicle" | translate }}
        <span *ngIf="updatesTabs.includes('vehicle')" class="violet-dot"></span>
      </button>
    </div>

    <div id="btn-bastidores" class="document-button" [ngClass]="activeForm == 'bastidores' ? 'selected' : ''"
      (click)="emitchangeForm('bastidores')" *ngIf="!hideTab('bastidores')">
      <button type="submit" class="btn-documents">
        <i class="icon-list"></i>
        {{ "forms.buttons.bastidores" | translate }}
      </button>
    </div>

    <div id="btn-timeline" class="document-button" [ngClass]="activeForm == 'timeline' ? 'selected' : ''"
      (click)="emitchangeForm('timeline')" *ngIf="!hideTab('timeline')">
      <button type="submit" class="btn-documents">
        <i class="icon-align-left"></i>
        {{ "forms.buttons.timeline" | translate }}
        <span *ngIf="updatesTabs.includes('timeline')" class="violet-dot"></span>
      </button>
    </div>

  </div>
</div>
